module.exports = __webpack_public_path__ + "img/instructions_nav.d480d406.png";